(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["blackland-oil-still-life"] && !Shopify.designMode) return;
  try {
    class BlacklandOilStillLife extends HTMLElement {
    #observer;
    #animation;
    #abort;
    #image;
    #motion;
    #visible = false;
    #played = false;

    connectedCallback() {
      if (this.#played || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
      this.#image = this.querySelector('.bl-oil-still-life__image');
      if (!this.#image) return;
      this.#motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.#motion.matches) {
        this.#played = true;
        return;
      }

      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.#motion.addEventListener('change', this.#onMotionChange, { signal });
      this.#image.addEventListener('load', this.#reveal, { signal });
      this.#observer = new IntersectionObserver((entries) => {
        this.#visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .35;
        this.#reveal();
      }, { threshold: .35 });
      this.setAttribute('data-entrance-pending', '');
      this.#observer.observe(this.querySelector('.bl-oil-still-life__scene'));
    }

    disconnectedCallback() {
      this.#cleanup();
      this.#visible = false;
    }

    #reveal = () => {
      if (!this.isConnected || this.#played || !this.#visible || !this.#image.complete
        || !this.#image.naturalWidth || this.#motion.matches) return;
      this.#played = true;
      this.#observer.disconnect();
      this.#animation = this.#image.animate([
        { opacity: .65, transform: 'translateY(16px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ], { duration: 2000, easing: 'cubic-bezier(.25, .46, .45, .94)' });
      this.removeAttribute('data-entrance-pending');
      this.#animation.addEventListener('finish', () => this.#cleanup(), { once: true });
    };

    #onMotionChange = () => {
      if (!this.#motion.matches) return;
      this.#played = true;
      this.#cleanup();
    };

    #cleanup() {
      this.removeAttribute('data-entrance-pending');
      this.#observer?.disconnect();
      this.#abort?.abort();
      this.#animation?.cancel();
      this.#animation = null;
    }
  }

  if (!customElements.get('blackland-oil-still-life')) {
    customElements.define('blackland-oil-still-life', BlacklandOilStillLife);
  }
  } catch(e) { console.error(e); }
})();

})();
